import { NgModule } from '@angular/core';

import { DistributorRoutingModule } from './distributor.routing';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListDistributorComponent } from './list-distributor/list-distributor.component';
import { DistributorFormComponent } from './components/distributor-form/distributor-form.component';
import { CreateDistributorComponent } from './create-distributor/create-distributor.component';
import { UpdateDistributorComponent } from './update-distributor/update-distributor.component';
import { TestSendNewsletterEmailComponent } from './test-send-newsletter-email/test-send-newsletter-email.component';

@NgModule({
  declarations: [
    ListDistributorComponent,
    DistributorFormComponent,
    CreateDistributorComponent,
    UpdateDistributorComponent,
    TestSendNewsletterEmailComponent
  ],
  imports: [SharedModule, DistributorRoutingModule]
})
export class DistributorModule {}
